import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { useTranslation } from "react-i18next"
import { SalesForceIntegrationModels } from "schema"
import { ConfigureModel } from "./ConfigureModel"

export const AvailableModels = () => {
  const { t } = useTranslation()
  const models = [
    {
      name: SalesForceIntegrationModels.enum.CONTACT,
      title: t("settings.integrations.salesForce.models.contact.title"),
      description: t("settings.integrations.salesForce.models.contact.description"),
    },
  ]

  return (
    <Section
      title={t("settings.integrations.salesForce.models.title")}
      description={t("settings.integrations.salesForce.models.description")}
    >
      <div className="grid lg:grid-cols-2 xl:grid-cols-3">
        {models.map((model) => (
          <Card key={model.title}>
            <CardHeader className="flex flex-col">
              <CardTitle>{model.title}</CardTitle>
              <CardDescription>{model.description}</CardDescription>
            </CardHeader>
            <CardFooter>
              <ConfigureModel model={model.name} />
            </CardFooter>
          </Card>
        ))}
      </div>
    </Section>
  )
}
